import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type { StAdjustmentTechnicianGroup } from "@/payroll/pay-breakdown/st-adjustments/types";

// Who this row's pay belongs to. The name leads and the ServiceTitan id sits
// under it: the name is what tells you whose money you are moving, while the id
// is what you need when reconciling against ServiceTitan itself.
export const TECHNICIAN_COLUMN: ColumnDef<
  StAdjustmentTechnicianGroup,
  unknown
> = {
  id: "technician",
  header: "Technician",
  enableSorting: false,
  meta: { size: "20rem" },
  cell: ({ row }) => {
    const { employee_id: employeeId, technicianName } = row.original;

    if (!employeeId) {
      return <Text tone="muted">Unknown technician</Text>;
    }

    return (
      <Stack align="start" gap={0}>
        {technicianName && (
          <Text className="truncate" title={technicianName}>
            {technicianName}
          </Text>
        )}
        <Text
          variant={technicianName ? undefined : undefined}
          tone={technicianName ? "muted" : undefined}
        >
          #{employeeId}
        </Text>
      </Stack>
    );
  },
};
